import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "./Icons";

function Projeto({ route, titulo, descricao, capa, tags = [], num }) {
  return (
    <Link to={route} className="proj-card">
      <div className="proj-thumb">
        {num != null && <span className="proj-num">{num}</span>}
        <img src={capa} alt={titulo} loading="lazy" />
      </div>
      <div className="proj-body">
        <h3>{titulo}</h3>
        <p>{descricao}</p>
        <div className="proj-tags">
          {tags.map((t) => (
            <span className="tag" key={t}>
              {t}
            </span>
          ))}
        </div>
        <span className="proj-foot">
          Ver projeto <ArrowRight />
        </span>
      </div>
    </Link>
  );
}

export default Projeto;
